// src/hooks/useErase.js
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { resetOperation } from '../redux/operationSlice';
import { clearSelection } from '../redux/selectionSlice';
import { COMMANDS } from '../utils/commonProperties';
import { DeleteCommand } from '../modules/undoRedo';

const useErase = (scene) => {
  const dispatch = useDispatch();
  const { commandType } = useSelector((state) => state.operation);
  const selectedObjectIds = useSelector((state) => state.selection.selectedObjectIds);

  const eraseObjects = () => {
    if (!scene || selectedObjectIds.length === 0) return;

    const toRemove = scene.children.filter(
      (obj) => selectedObjectIds.includes(obj.userData?.id)
    );

    if (toRemove.length === 0) return;

    // dispose çağrılmadan önce komut geçmişine ekle — undo için nesneler canlı tutulur
    const manager = window.undoRedoManager;
    if (manager) {
      const tx = manager.beginTransaction('Delete Objects');
      manager.addCommand(new DeleteCommand(toRemove));
      manager.commitTransaction(tx);
    }

    // Geometriyi dispose etmeden sadece sahneden kaldır
    toRemove.forEach((obj) => scene.remove(obj));

    dispatch(clearSelection());
    dispatch(resetOperation());
  };

  useEffect(() => {
    if (commandType === COMMANDS.ERASE) {
      eraseObjects();
    }
  }, [commandType]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Delete') {
        eraseObjects();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [scene, selectedObjectIds]);
};

export default useErase;
